module.exports = __webpack_public_path__ + "img/linkedin-logo-white.3ec66b9e.svg";